// Módulo mkt-delivery-date: sustituye el plazo en días del metacampo («Entrega en 2-3 días», «48 horas») por la fecha
// en que estará disponible el producto, a partir de hoy + plazo (con ceil(h / 24) días si el plazo está en horas).
// Configuración en window.mktDeliveryDate (la escribe snippets/mkt-store-config.liquid): { locale, from, range }.
// - Ficha: plazo fijo («48 horas») => «Entrega a partir del 29/10»; rango («3-6 días») => «Entrega estimada entre
//   el 30/10 y 02/11» (hoy + mínimo y hoy + máximo).
// - Tarjeta de producto (dentro de .product-card): solo el primer día del rango, «Entrega a partir del 30/10».
// - Con envío gratis en el mismo texto se conserva delante de la fecha («Envío GRATIS · Entrega a partir del…»).
// - Con unidad de días laborables (laborables, Werktage, ouvrés, lavorativi…) se saltan sábados y domingos.
// - Textos sin plazo con unidad (p. ej. «a partir del 3 de noviembre») no se tocan.
// - Marcadores de los textos: __DM1__/__DM2__ fecha numérica día/mes (30/10; en DE y con la página en neerlandés «30.10.»; en en-US mes/día).
// - Elementos: .metafield-envio.cc, los p de .shipping-info en la tarjeta (envío gratis) y .metafield-tiempo_de_entrega.cc. La ficha reescribe su texto al cambiar de variante,
//   por eso un observador reprocesa lo que cambie; lo ya pintado por este script se reconoce y se ignora.
(function () {
  const config = window.mktDeliveryDate;
  if (!config || !config.from) return;
  if (window.__mktDeliveryDateLoaded) return;
  window.__mktDeliveryDateLoaded = true;

  const SELECTOR = '.metafield-envio.cc, .product-card .shipping-info p, .metafield-tiempo_de_entrega.cc:not(.delivery-estimate)';
  const LOCALE = config.locale || document.documentElement.lang || 'es-ES';
  const LANG = LOCALE.slice(0, 2).toLowerCase();
  const PAGE_LANG = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
  const RANGE = /(\d+)(?:\s*(?:-|\/|–|—|a|à|bis|e|y|to)\s*(\d+))?\s*((?:werk)?tage?n?|(?:werk)?dag(?:en)?|d[ií]as?|jours?|giorni|days?|horas?|heures?|stunden?|ore|hours?|uren|uur|h)(?![a-zà-ú])/i;
  const HOURS = /^(horas?|heures?|stunden?|ore|hours?|uren|uur|h)$/i;
  const BUSINESS = /(h[áa]bil|laborable|werktag|werkdag|ouvr|lavorativ|business|weekday)/i;
  const FREE = /(gratis|gratuit|kostenlos|free)/i;
  const rendered = new WeakMap();

  function isWeekend(d) {
    return d.getDay() === 0 || d.getDay() === 6;
  }

  function addDays(base, n, business) {
    const d = new Date(base.getTime());
    for (let i = 0; i < n; i++) {
      d.setDate(d.getDate() + 1);
      while (business && isWeekend(d)) d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function dateLabel(d) {
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    if (LOCALE === 'en-US') return mm + '/' + dd;
    if (LANG === 'de' || PAGE_LANG === 'nl') return dd + '.' + mm + '.';
    return dd + '/' + mm;
  }

  function fill(template, d1, d2) {
    return template.replace(/__DM1__/g, dateLabel(d1)).replace(/__DM2__/g, dateLabel(d2));
  }

  // range: solo en la ficha y con plazo variable; en la tarjeta y con plazo fijo, «a partir del» primer día
  function sentence(minDays, maxDays, business, range, card) {
    const today = new Date();
    today.setHours(12, 0, 0, 0);
    const d1 = addDays(today, minDays, business);
    // Tarjeta: texto propio (store_texts.delivery_estimated_card) si la tienda lo define
    if (card && config.card) return fill(config.card, d1, d1);
    if (!range || maxDays <= minDays) return fill(config.from, d1, d1);
    const d2 = addDays(today, maxDays, business);
    return fill(config.range || config.from, d1, d2);
  }

  function toDays(value, unit) {
    return HOURS.test(unit) ? Math.ceil(value / 24) : value;
  }

  // Devuelve { minDays, maxDays, business, before } del plazo del texto, o null si no hay plazo con unidad
  function parse(text) {
    const clean = text.replace(/\s+/g, ' ').trim();
    const m = clean.match(RANGE);
    if (!m) return null;
    const a = parseInt(m[1], 10);
    const b = m[2] ? parseInt(m[2], 10) : a;
    if (!(Math.max(a, b) > 0)) return null;
    return {
      minDays: toDays(Math.min(a, b), m[3]),
      maxDays: toDays(Math.max(a, b), m[3]),
      business: BUSINESS.test(clean),
      before: clean.slice(0, m.index),
    };
  }

  // Contenedor del texto: .metafield-envio__text, el último span o el propio elemento
  function holder(el) {
    return el.querySelector('.metafield-envio__text') || Array.from(el.querySelectorAll('span')).pop() || el;
  }

  function process(el) {
    // Marca el elemento como tratado: el CSS de mkt-delivery-pending lo mantiene en blanco hasta entonces
    el.setAttribute('data-mkt-date', '');
    const node = holder(el);
    const current = node.textContent;
    if (rendered.get(node) === current) return;
    const p = parse(current);
    if (!p) return;
    const hasFree = FREE.test(p.before);
    // El rango completo solo cabe en la ficha; la tarjeta enseña el primer día
    const inCard = !!el.closest('.product-card');
    const out = sentence(p.minDays, p.maxDays, p.business, !inCard, inCard);
    // Envío gratis en el mismo texto («Envío GRATIS 3-5 días»): se conserva delante de la fecha
    const lead = node.querySelector('strong');
    if (lead) {
      const text = document.createTextNode(' · ' + out);
      Array.from(node.childNodes).forEach((c) => {
        if (c !== lead) node.removeChild(c);
      });
      node.appendChild(text);
      rendered.set(node, node.textContent);
      return;
    }
    const full = hasFree ? p.before.replace(/[\s:·-]+$/, '') + ' · ' + out : out;
    node.textContent = full;
    rendered.set(node, full);
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(process);
  }

  let queued;
  function start() {
    scan();
    new MutationObserver(() => {
      clearTimeout(queued);
      queued = setTimeout(scan, 50);
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
